import classNames from 'classnames'
import {memo} from 'react'

import styles from './ParameterIcon.css'

interface Props {
  className: string
}

function ParameterIconComponent(props: Props) {
  return (
    <svg
      className={classNames(styles.icon, props.className)}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="50" r="50" />
    </svg>
  )
}

export const ParameterIcon = memo<Props>(ParameterIconComponent)
